import { createSlice } from "@reduxjs/toolkit";
import { offerPriceRequest } from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  offerRequestStatus: null, // "loading" | "success" | "failed"
  error: null,
};

export const offerPriceSlice = createSlice({
  name: "offerPrice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(offerPriceRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(offerPriceRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.offerRequestStatus = action.payload;
        if (action?.payload?.status == 1) {
          message.success(action?.payload?.message);
        } else {
          const msg = Array.isArray(action?.payload?.message)
            ? action.payload.message?.join(", ")
            : action.payload.message;

          message.error(msg);
        }
      })
      .addCase(offerPriceRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.offerRequestStatus = action.payload;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default offerPriceSlice.reducer;
